import {
  GET_ADMIN_STATIC_DATA,
  SET_ADMIN_STATIC_DATA,
} from "./AdminStaticDataTypes";

const getAdminStaticData = () => {
  return {
    type: GET_ADMIN_STATIC_DATA,
  };
};
const setAdminStaticData = (data) => {
  return {
    type: SET_ADMIN_STATIC_DATA,
    payload: data,
  };
};
const AdminStaticDataAction = { getAdminStaticData, setAdminStaticData };
export default AdminStaticDataAction;
